import { render, staticRenderFns } from "./bottomController.vue?vue&type=template&id=53c03eeb&scoped=true&"
import script from "./bottomController.vue?vue&type=script&lang=js&"
export * from "./bottomController.vue?vue&type=script&lang=js&"
import style0 from "./bottomController.vue?vue&type=style&index=0&id=53c03eeb&prod&lang=scss&"
import style1 from "./bottomController.vue?vue&type=style&index=1&id=53c03eeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c03eeb",
  null
  
)

export default component.exports